export default __webpack_public_path__ + "static/media/e1.fb1c2196.jpeg";